import { Divider, Grid, Stack, Typography } from "@mui/material";
import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { OrderItemList } from "../OrderItemList";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { CardWithTitle } from "@common/CardWithTitle/CardWithTitle";
import { TCancelOrder } from "../type/TCancelOrder";
import { useCurrentOrder } from "@features/Order/current/useCurrentOrder";

interface IParams {
    cancelOrder: TCancelOrder;
    isHomePage?: boolean;
}

export const CurrentOrder = (props: IParams) => {
    const { cancelOrder: parentCancelOrder, isHomePage } = props;
    const { cancelOrder, orderList, getOrdersState, getOrders } = useCurrentOrder({ parentCancelOrder });
    const { t } = useTranslation("order");

    useEffect(() => {
        getOrders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isHomePage && orderList.length === 0) {
        return null;
    }

    return (
        <CardWithTitle title={t("myCurrentOrder")}>
            <HandleErrorAndLoading isLoading={getOrdersState.isLoading}>
                {orderList.length > 0 ? (
                    <Stack spacing={3}>
                        {orderList.map((order, index) => (
                            <Fragment key={order.reference}>
                                <OrderItemList cancelOrder={cancelOrder} offerList={order.offers} order={order} />
                                {orderList.length !== index + 1 && <Divider variant="fullWidth" />}
                            </Fragment>
                        ))}
                    </Stack>
                ) : (
                    <Grid alignContent="center" container direction="column">
                        <Typography color="secondary" variant="h5">
                            {t("noOrders")}
                        </Typography>
                        <Typography color="textSecondary" variant="normal">
                            {t("nextOrders")}
                        </Typography>
                    </Grid>
                )}
            </HandleErrorAndLoading>
        </CardWithTitle>
    );
};
